/**
 * Featured Collection Tabs - Premium Shopify Component Script
 * Manages responsive tab swaps, CSS scroll snap carousel navs, and interactivity
 */

// Global Cart Simulation State Manager for Wearjags Premium

document.addEventListener('DOMContentLoaded', function() {
  if (window.ShopifyCart && typeof window.ShopifyCart.updateHeaderCount === 'function') {
    window.ShopifyCart.updateHeaderCount();
  }
  initCollectionTabs();
});

function initCollectionTabs() {
  const sections = document.querySelectorAll('.featured-collections-tabs');
  
  sections.forEach((section) => {
    const tabButtons = section.querySelectorAll('.featured-collections-tabs__tab-btn');
    const panels = section.querySelectorAll('.featured-collections-tabs__panel');
    let transitionTimeout = null;
    
    // 1. Swapping tabs logic
    tabButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        
        const activeBlockId = btn.getAttribute('data-block-id');
        const targetPanel = section.querySelector(`#TabPanel-${activeBlockId}`);
        const currentPanel = section.querySelector('.featured-collections-tabs__panel.is-active');
        
        if (currentPanel === targetPanel) return;
        
        // Interrupt any ongoing transition to prevent state inconsistency
        if (transitionTimeout) {
          clearTimeout(transitionTimeout);
          transitionTimeout = null;
          
          panels.forEach(p => {
            p.classList.remove('tab-panel-fade-out', 'tab-panel-preparing', 'is-active');
            p.hidden = true;
          });
        }
        
        // Remove active states from buttons
        tabButtons.forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        
        // Add active states to clicked button
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        
        if (currentPanel) {
          // Step 1: Smoothly fade out current products
          currentPanel.classList.add('tab-panel-fade-out');
          currentPanel.classList.remove('is-active');
          
          transitionTimeout = setTimeout(() => {
            currentPanel.hidden = true;
            currentPanel.classList.remove('tab-panel-fade-out');
            transitionTimeout = null;
            
            // Step 2 & 3: Load and smoothly fade in + slide up new products
            if (targetPanel) {
              targetPanel.hidden = false;
              targetPanel.classList.add('tab-panel-preparing');
              
              // Force local layout reflow to register the starting transition state
              targetPanel.offsetHeight;
              
              targetPanel.classList.remove('tab-panel-preparing');
              targetPanel.classList.add('is-active');
              
              // Re-trigger scroll event to align slider arrow states
              const track = targetPanel.querySelector('[data-carousel-track]');
              if (track) {
                track.dispatchEvent(new Event('scroll'));
              }
            }
          }, 250); // Elegant fade out duration
        } else {
          // If no current active panel, show target panel instantly with standard activation
          if (targetPanel) {
            targetPanel.hidden = false;
            targetPanel.classList.add('is-active');
            
            const track = targetPanel.querySelector('[data-carousel-track]');
            if (track) {
              track.dispatchEvent(new Event('scroll'));
            }
          }
        }
      });
    });

    // 2. Carousel Sliders Logic inside each active panel template
    const sliderContainers = section.querySelectorAll('[data-slider-container]');
    sliderContainers.forEach((container) => {
      const track = container.querySelector('[data-carousel-track]');
      const btnPrev = container.querySelector('[data-arrow-prev]');
      const btnNext = container.querySelector('[data-arrow-next]');
      
      if (!track || !btnPrev || !btnNext) return;

      // Handle Arrow clicks
      btnPrev.addEventListener('click', () => {
        const itemWidth = track.firstElementChild ? track.firstElementChild.offsetWidth : 220;
        const visibleWidth = track.clientWidth;
        track.scrollBy({
          left: -visibleWidth + 60,
          behavior: 'smooth'
        });
      });

      btnNext.addEventListener('click', () => {
        const itemWidth = track.firstElementChild ? track.firstElementChild.offsetWidth : 220;
        const visibleWidth = track.clientWidth;
        track.scrollBy({
          left: visibleWidth - 60,
          behavior: 'smooth'
        });
      });

      // Update button states on scroll
      function updateArrowsState() {
        const scrollLeft = track.scrollLeft;
        const maxScroll = track.scrollWidth - track.clientWidth;

        // At start position
        if (scrollLeft <= 4) {
          btnPrev.setAttribute('disabled', 'true');
        } else {
          btnPrev.removeAttribute('disabled');
        }

        // At end position
        if (scrollLeft >= maxScroll - 4) {
          btnNext.setAttribute('disabled', 'true');
        } else {
          btnNext.removeAttribute('disabled');
        }
      }

      // Listen to scroll events on track (throttled/debounced implicitly by standard browser rendering)
      track.addEventListener('scroll', updateArrowsState);
      
      // Initial trigger to configure arrow states properly
      updateArrowsState();

      // Trigger resize update on window resize (prevents layout lockups when shifting orientation)
      window.addEventListener('resize', () => {
        setTimeout(updateArrowsState, 150);
      });
    });


    // 4. Premium Hover Quick Add Overlay Logic
    const colorMap = {
      'black': '#000000',
      'white': '#ffffff',
      'grey': '#828282',
      'gray': '#828282',
      'navy': '#000080',
      'navy blue': '#1b2c41',
      'charcoal': '#333333',
      'midnight': '#121212',
      'midnight charcoal': '#1c1d21',
      'aura white': '#f5f7f8',
      'cognac': '#8b5a2b',
      'cognac leather': '#9c5b2a',
      'tan': '#d2b48c',
      'classic tan': '#c68d59',
      'emerald': '#046307',
      'emerald green': '#044c29',
      'blue': '#0000ff',
      'crimson': '#dc143c',
      'crimson red': '#a00e1e',
      'satin grey': '#7a818c',
      'satin grey/silver': '#a8a9ad',
      'silver': '#c0c0c0',
      'rose': '#ff007f',
      'pink': '#ffc0cb',
      'gold': '#ffd700',
      'beige': '#f5f5dc',
      'sand': '#e5c59f',
      'khaki': '#f0e68c',
      'olive': '#808000',
      'forest green': '#228b22',
      'sage': '#9c9f84',
      'lilac': '#c8a2c8',
      'lavender': '#e6e6fa'
    };

    const cards = section.querySelectorAll('.custom-premium-product-card');
    cards.forEach((card) => {
      const overlay = card.querySelector('.premium-product-card__quick-add-overlay');
      if (!overlay) return;

      // Stop all click events inside the glass overlay from propagating outward to product page link triggers
      overlay.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      // Update theme dynamically on hover or click/focus
      const updateTheme = () => {
        const headerEl = document.querySelector('header-section');
        let theme = headerEl ? headerEl.getAttribute('data-theme-mode') : 'dark';
        if (theme === 'auto' || !theme) {
          theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        }
        overlay.setAttribute('data-theme', theme);
      };

      card.addEventListener('mouseenter', updateTheme);
      card.addEventListener('touchstart', updateTheme, { passive: true });
      card.addEventListener('focusin', updateTheme);

      // Parse JSON
      const scriptEl = card.querySelector('.product-data-json');
      if (!scriptEl) return;

      let productData;
      try {
        productData = JSON.parse(scriptEl.textContent);
      } catch (err) {
        console.error('Failed to parse card product details JSON:', err);
        return;
      }

      const rawVariants = productData.variants || [];
      const normalizedVariants = rawVariants.map((v) => {
        let opts = v.options || [];
        if (opts.length === 0 && v.title) {
          opts = v.title.split('/').map(part => part.trim());
        }
        return {
          id: String(v.id),
          title: v.title,
          available: v.available !== false,
          options: opts
        };
      });

      let optionsList = productData.options || [];
      if (optionsList.length === 0) {
        const maxOptsCount = Math.max(...normalizedVariants.map(v => v.options.length), 0);
        if (maxOptsCount === 1) {
          const isSizeCandidate = (val) => {
            if (!val) return false;
            const normalized = val.trim().toLowerCase();
            const sizeIndicators = ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xs', 'xxs', 'os', 'one size', 'small', 'medium', 'large', 'x-large'];
            return sizeIndicators.includes(normalized) || /^[0-9]+(\.[0-9]+)?$/.test(normalized);
          };
          if (normalizedVariants.some(v => isSizeCandidate(v.options[0]))) {
            optionsList = ['Size'];
          } else {
            optionsList = ['Color'];
          }
        } else if (maxOptsCount >= 2) {
          optionsList = ['Color', 'Size'];
        }
      }

      let colorIdx = optionsList.findIndex(opt => {
        const l = opt.toLowerCase();
        return l.includes('color') || l.includes('colour') || l.includes('shade') || l.includes('edition') || l.includes('style');
      });
      let sizeIdx = optionsList.findIndex(opt => {
        const l = opt.toLowerCase();
        return l.includes('size') || l.includes('fit') || l.includes('dimension');
      });

      if (colorIdx === -1 && sizeIdx === -1 && optionsList.length > 0) {
        const firstV = normalizedVariants[0];
        if (firstV && firstV.options.length > 0) {
          const isSizeCandidate = (val) => {
            if (!val) return false;
            const normalized = val.trim().toLowerCase();
            const sizeIndicators = ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xs', 'xxs', 'os', 'one size', 'small', 'medium', 'large', 'x-large'];
            return sizeIndicators.includes(normalized) || /^[0-9]+(\.[0-9]+)?$/.test(normalized);
          };
          if (firstV.options.length === 1) {
            if (isSizeCandidate(firstV.options[0])) {
              sizeIdx = 0;
            } else {
              colorIdx = 0;
            }
          } else if (firstV.options.length >= 2) {
            if (isSizeCandidate(firstV.options[0])) {
              sizeIdx = 0;
              colorIdx = 1;
            } else {
              colorIdx = 0;
              sizeIdx = 1;
            }
          }
        }
      }

      // Generate unique Colors list (available only)
      let colorsList = [];
      if (colorIdx !== -1) {
        normalizedVariants.forEach(v => {
          const colVal = v.options[colorIdx];
          if (colVal && v.available) {
            if (!colorsList.includes(colVal)) {
              colorsList.push(colVal);
            }
          }
        });
      }

      // Generate unique Sizes list
      let sizesList = [];
      if (sizeIdx !== -1) {
        normalizedVariants.forEach(v => {
          const sizeVal = v.options[sizeIdx];
          if (sizeVal && !sizesList.includes(sizeVal)) {
            sizesList.push(sizeVal);
          }
        });
      }

      // Rebuild Desktop Quick Add Content
      const container = card.querySelector('.quick-add-overlay__container');
      if (container) {
        let colorsHtml = '';
        if (colorsList.length > 0) {
          colorsHtml = `
            <div class="quick-add-overlay__swatches">
          `;
          colorsList.forEach((colName) => {
            const allImages = productData.images || [];
            const allAlts = productData.images_alt || [];
            const lowerColor = colName.trim().toLowerCase();
            let matchedImg = null;
            for (let i = 0; i < allImages.length; i++) {
              const alt = (allAlts[i] || '').trim().toLowerCase();
              if (alt.includes(lowerColor)) {
                matchedImg = allImages[i];
                break;
              }
            }
            if (!matchedImg) {
              matchedImg = allImages[0] || '';
            }
            colorsHtml += `
              <button 
                type="button" 
                class="quick-add-color-swatch-btn" 
                data-color-val="${colName}" 
                title="${colName}"
                aria-label="Select color ${colName}"
              >
                <img src="${matchedImg}" alt="${colName}" referrerPolicy="no-referrer" />
              </button>
            `;
          });
          colorsHtml += `
            </div>
          `;
        }

        let sizesHtml = '';
        if (sizesList.length > 0) {
          sizesHtml = `
            <div class="quick-add-overlay__sizes" style="display: none;">
            </div>
          `;
        }

        const submitBtnHtml = `
          <button type="button" class="quick-add-submit-btn" disabled aria-label="Add to cart">
            ADD
          </button>
        `;

        container.innerHTML = colorsHtml + sizesHtml + submitBtnHtml;

        const colorBtns = container.querySelectorAll('.quick-add-color-swatch-btn');
        const sizesDiv = container.querySelector('.quick-add-overlay__sizes');
        const submitBtn = container.querySelector('.quick-add-submit-btn');

        let selectedCardColor = null;
        let selectedCardSize = null;

        const getImagesForColorInCard = (color) => {
          const allImages = productData.images || [];
          const allAlts = productData.images_alt || [];
          if (!color) return allImages;
          const lowerColor = color.trim().toLowerCase();
          let matched = [];
          allImages.forEach((img, idx) => {
            const alt = (allAlts[idx] || '').trim().toLowerCase();
            if (alt.includes(lowerColor)) {
              matched.push(img);
            }
          });
          return matched.length > 0 ? matched : allImages;
        };

        const updateCardState = () => {
          // Image swap / revert
          const imgPrimary = card.querySelector('.product-card__image--primary');
          const imgSecondary = card.querySelector('.product-card__image--secondary');
          const originalImages = productData.images || [];

          if (selectedCardColor) {
            const colorImages = getImagesForColorInCard(selectedCardColor);
            if (colorImages && colorImages.length > 0) {
              const primaryColorImage = colorImages[0];
              const secondaryColorImage = colorImages[1] || colorImages[0];
              
              if (imgPrimary && primaryColorImage) {
                imgPrimary.setAttribute('src', primaryColorImage);
              }
              if (imgSecondary && secondaryColorImage) {
                imgSecondary.setAttribute('src', secondaryColorImage);
              }
            }
          } else {
            // Revert to original product images
            if (imgPrimary && originalImages[0]) {
              imgPrimary.setAttribute('src', originalImages[0]);
            }
            if (imgSecondary && originalImages[1]) {
              imgSecondary.setAttribute('src', originalImages[1]);
            } else if (imgSecondary && originalImages[0]) {
              imgSecondary.setAttribute('src', originalImages[0]);
            }
          }

          // If color is required but not selected
          if (colorsList.length > 0 && !selectedCardColor) {
            if (sizesDiv) sizesDiv.style.display = 'none';
            submitBtn.setAttribute('disabled', 'true');
            submitBtn.innerHTML = 'ADD';
            return;
          }

          // If color is selected, show sizes
          if (sizesDiv) {
            sizesDiv.style.display = 'flex';
            let sizesContent = '';
            sizesList.forEach((sVal) => {
              const variant = normalizedVariants.find(v => {
                const hasColorMatch = colorIdx === -1 ? true : v.options[colorIdx] === selectedCardColor;
                const hasSizeMatch = sizeIdx === -1 ? true : v.options[sizeIdx] === sVal;
                return hasColorMatch && hasSizeMatch;
              });

              if (variant && variant.available) {
                const activeClass = sVal === selectedCardSize ? 'is-selected' : '';
                sizesContent += `
                  <button 
                    type="button" 
                    class="quick-add-size-btn ${activeClass}" 
                    data-variant-id="${variant.id}" 
                    data-size="${sVal}"
                    aria-label="Select size ${sVal}"
                  >
                    ${sVal}
                  </button>
                `;
              }
            });
            sizesDiv.innerHTML = sizesContent;

            // Bind newly created size buttons click
            const sizeBtns = sizesDiv.querySelectorAll('.quick-add-size-btn');
            sizeBtns.forEach((btn) => {
              btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const wasSelected = btn.classList.contains('is-selected');
                sizeBtns.forEach(b => b.classList.remove('is-selected'));

                if (wasSelected) {
                  selectedCardSize = null;
                  submitBtn.setAttribute('disabled', 'true');
                } else {
                  btn.classList.add('is-selected');
                  selectedCardSize = btn.getAttribute('data-size');
                  submitBtn.removeAttribute('disabled');
                  submitBtn.setAttribute('data-target-variant-id', btn.getAttribute('data-variant-id'));
                }
              });
            });
          }

          // Button enablement check
          if (sizesList.length > 0) {
            if (selectedCardColor && selectedCardSize) {
              submitBtn.removeAttribute('disabled');
            } else {
              submitBtn.setAttribute('disabled', 'true');
            }
          } else {
            if (selectedCardColor) {
              submitBtn.removeAttribute('disabled');
              const matchingV = normalizedVariants.find(v => v.options[colorIdx] === selectedCardColor);
              if (matchingV) {
                submitBtn.setAttribute('data-target-variant-id', matchingV.id);
              }
            } else {
              submitBtn.setAttribute('disabled', 'true');
            }
          }
        };

        // Bind color button clicks
        colorBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const wasActive = btn.classList.contains('is-active');
            colorBtns.forEach(b => b.classList.remove('is-active'));

            if (wasActive) {
              selectedCardColor = null;
              selectedCardSize = null;
            } else {
              btn.classList.add('is-active');
              selectedCardColor = btn.getAttribute('data-color-val');
              selectedCardSize = null;
            }
            updateCardState();
          });
        });

        // Submit listener for newly created CTA
        submitBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const targetVariantId = submitBtn.getAttribute('data-target-variant-id');
          if (!targetVariantId) return;

          // STEP 1 - IMMEDIATE PREMIUM FEEDBACK
          const originalText = submitBtn.innerHTML;
          submitBtn.innerHTML = '✓ Added to Cart';
          submitBtn.classList.add('success-flash');
          submitBtn.setAttribute('disabled', 'true');

          const titleEl = card.querySelector('.premium-product-card__title a') || card.querySelector('.premium-product-card__title');
          const titleText = titleEl ? titleEl.textContent.trim() : 'Premium Item';
          
          const priceEl = card.querySelector('.premium-product-card__price .price-item') || card.querySelector('.premium-product-card__price');
          const priceText = priceEl ? priceEl.textContent.trim() : '$320.00';
          
          const imgEl = card.querySelector('.product-card__image--primary');
          const imgSrc = imgEl ? imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '' : '';
          
          const sizeStr = selectedCardSize || 'S';
          const colorStr = selectedCardColor || 'Signature Black';

          if (window.ShopifyCart && typeof window.ShopifyCart.addItem === 'function') {
            window.ShopifyCart.addItem({
              id: targetVariantId,
              title: titleText,
              price: priceText,
              image: imgSrc,
              size: sizeStr,
              color: colorStr
            });
          }

          if (targetVariantId.startsWith('placeholder-')) {
            setTimeout(() => {
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else {
                const cartNotification = document.querySelector('cart-notification');
                if (cartNotification && typeof cartNotification.open === 'function') {
                  cartNotification.open();
                }
              }

              // Reset selections
              colorBtns.forEach(b => b.classList.remove('is-active'));
              if (sizesDiv) {
                sizesDiv.style.display = 'none';
                sizesDiv.innerHTML = '';
              }
              selectedCardColor = null;
              selectedCardSize = null;
              
              setTimeout(() => {
                submitBtn.innerHTML = 'ADD';
                submitBtn.classList.remove('success-flash');
                submitBtn.setAttribute('disabled', 'true');
              }, 1200);
            }, 500);
          } else if (!window.ShopifyCart || typeof window.ShopifyCart.addItem !== 'function') {
            const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
            const formData = new FormData();
            formData.append('id', targetVariantId);
            formData.append('quantity', '1');

            const cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
            if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
              const sectionsToRender = cartElement.getSectionsToRender();
              if (sectionsToRender && Array.isArray(sectionsToRender)) {
                const sectionIds = sectionsToRender.map(s => s.id).join(',');
                formData.append('sections', sectionIds);
              }
              formData.append('sections_url', window.location.pathname);
            }

            fetch(addUrl, {
              method: 'POST',
              body: formData,
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
              }
            })
            .then(res => res.json())
            .then(data => {
              return fetch(window.Shopify && window.Shopify.routes ? `${window.Shopify.routes.root}cart.js` : '/cart.js')
                .then(r => r.json())
                .then(cartData => {
                  document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartData } }));
                  document.dispatchEvent(new CustomEvent('wearjags-cart-updated', { bubbles: true }));
                  
                  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: targetVariantId, cartData: cartData });
                  }
                  
                  if (window.ShopifyCart && typeof window.ShopifyCart.refresh === 'function') {
                    window.ShopifyCart.refresh();
                  } else {
                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
                  }

                  setTimeout(() => {
                    colorBtns.forEach(b => b.classList.remove('is-active'));
                    if (sizesDiv) {
                      sizesDiv.style.display = 'none';
                      sizesDiv.innerHTML = '';
                    }
                    selectedCardColor = null;
                    selectedCardSize = null;
                    setTimeout(() => {
                      submitBtn.innerHTML = 'ADD';
                      submitBtn.classList.remove('success-flash');
                      submitBtn.setAttribute('disabled', 'true');
                    }, 1200);
                  }, 500);
                });
            })
            .catch(err => {
              setTimeout(() => {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                }

                colorBtns.forEach(b => b.classList.remove('is-active'));
                if (sizesDiv) {
                  sizesDiv.style.display = 'none';
                  sizesDiv.innerHTML = '';
                }
                selectedCardColor = null;
                selectedCardSize = null;
                
                setTimeout(() => {
                  submitBtn.innerHTML = 'ADD';
                  submitBtn.classList.remove('success-flash');
                  submitBtn.removeAttribute('disabled');
                }, 1200);
              }, 500);
            });
          }
        });
      }

      // 5. Mobile Touch Tap Behavior and Mobile Quick Add Trigger
      const mobileQuickAddBtn = card.querySelector('.mobile-premium-quick-add-btn');
      if (mobileQuickAddBtn) {
        const updateBtnTheme = () => {
          const headerEl = document.querySelector('header-section');
          let theme = headerEl ? headerEl.getAttribute('data-theme-mode') : 'dark';
          if (theme === 'auto' || !theme) {
            theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
          }
          mobileQuickAddBtn.setAttribute('data-theme', theme);
        };
        updateBtnTheme();
        card.addEventListener('mouseenter', updateBtnTheme);
        card.addEventListener('touchstart', updateBtnTheme, { passive: true });

        // Bind standard click to open the modal
        mobileQuickAddBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openQuickAddModal(card);
        });

        // Also bind touchstart to open completely instantly with zero tap delay
        mobileQuickAddBtn.addEventListener('touchstart', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openQuickAddModal(card);
        }, { passive: false });
      }
    });
  });
}

/**
 * Perform Shopify Add to Cart Addition via AJAX
 * @param {string} variantId
 * @param {HTMLButtonElement} btnElement
 */
function addVariantToCart(variantId, btnElement) {
  const originalText = btnElement.textContent;
  btnElement.textContent = 'ADDING...';
  btnElement.setAttribute('disabled', 'true');
  
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');
  
  const cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
    const sectionsToRender = cartElement.getSectionsToRender();
    if (sectionsToRender && Array.isArray(sectionsToRender)) {
      const sectionIds = sectionsToRender.map(s => s.id).join(',');
      formData.append('sections', sectionIds);
    }
    formData.append('sections_url', window.location.pathname);
  }
  
  const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
  
  fetch(addUrl, {
    method: 'POST',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    }
  })
  .then(res => res.json())
  .then(data => {
    if (data.status && data.status === 422) {
      console.error('Add to cart error details:', data);
      showPremiumToast(`Error: ${data.description || data.message || 'Could not add to cart'}`);
      btnElement.textContent = 'FAILED';
      setTimeout(() => {
        btnElement.textContent = originalText;
        btnElement.removeAttribute('disabled');
      }, 2000);
      return;
    }

    return fetch(window.Shopify && window.Shopify.routes ? `${window.Shopify.routes.root}cart.js` : '/cart.js')
      .then(res => res.json())
      .then(cartData => {
        btnElement.textContent = 'ADDED!';

        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('wearjags-cart-updated', { bubbles: true }));

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form', 
            productVariantId: variantId, 
            cartData: cartData
          });
        }

        if (window.ShopifyCart && typeof window.ShopifyCart.refresh === 'function') {
          window.ShopifyCart.refresh();
        } else {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }

        const card = btnElement.closest('.custom-premium-product-card');
        if (card) {
          card.querySelectorAll('.quick-add-size-btn.is-selected').forEach(s => s.classList.remove('is-selected'));
        }

        setTimeout(() => {
          btnElement.textContent = 'ADD';
          btnElement.setAttribute('disabled', 'true');
        }, 1500);
      });
  })
  .catch(err => {
    console.error('Ajax Add to Cart failed:', err);
    btnElement.textContent = 'ERROR';
    setTimeout(() => {
      btnElement.textContent = 'ADD';
      btnElement.setAttribute('disabled', 'true');
    }, 1500);
  });
}

/**
 * Show a premium non-blocking overlay toast notifications in bottom corner
 * @param {string} message
 */
function showPremiumToast(message) {
  let toast = document.getElementById('premium-quickview-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'premium-quickview-toast';
    toast.style.position = 'fixed';
    toast.style.bottom = '24px';
    toast.style.right = '24px';
    toast.style.backgroundColor = '#121212';
    toast.style.color = '#ffffff';
    toast.style.padding = '12px 24px';
    toast.style.borderRadius = '4px';
    toast.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
    toast.style.fontFamily = "'Inter', sans-serif";
    toast.style.fontSize = '12px';
    toast.style.fontWeight = '500';
    toast.style.zIndex = '1000000';
    toast.style.transition = 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)';
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(10px)';
    document.body.appendChild(toast);
  }
  
  toast.innerText = message;
  toast.style.opacity = '1';
  toast.style.transform = 'translateY(0)';
  
  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(10px)';
  }, 2500);
}

// Setup Mobile-optimized Quick Add modal singleton
function setupMobileQuickAdd() {
  if (document.querySelector('.premium-quickview-backdrop')) return;

  const backdrop = document.createElement('div');
  backdrop.className = 'premium-quickview-backdrop';
  document.body.appendChild(backdrop);

  const modal = document.createElement('div');
  modal.className = 'premium-quickview-modal';
  modal.innerHTML = `
    <div class="premium-quickview-modal__drag-bar"></div>
    <div class="premium-quickview-modal__header">
      <button type="button" class="premium-quickview-modal__close-btn" aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="premium-quickview-modal__content"></div>
    <div class="premium-quickview-modal__footer"></div>
  `;
  document.body.appendChild(modal);

  // Close event listeners
  const closeBtn = modal.querySelector('.premium-quickview-modal__close-btn');
  closeBtn.addEventListener('click', closeQuickAddModal);
  backdrop.addEventListener('click', closeQuickAddModal);

  // Support swipe down to close
  let touchStartY = 0;
  let touchMoveY = 0;
  modal.addEventListener('touchstart', (e) => {
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  modal.addEventListener('touchmove', (e) => {
    touchMoveY = e.touches[0].clientY;
    const diffY = touchMoveY - touchStartY;
    const contentEl = modal.querySelector('.premium-quickview-modal__content');
    const scrollPos = contentEl ? contentEl.scrollTop : 0;
    if (diffY > 0 && scrollPos <= 0) {
      modal.style.transform = `translateY(${diffY}px) scaleY(${1 - (diffY / 1000)})`;
    }
  }, { passive: true });

  modal.addEventListener('touchend', (e) => {
    const diffY = touchMoveY - touchStartY;
    const contentEl = modal.querySelector('.premium-quickview-modal__content');
    const scrollPos = contentEl ? contentEl.scrollTop : 0;
    if (diffY > 80 && scrollPos <= 0) {
      closeQuickAddModal();
    } else {
      modal.style.transform = '';
    }
    touchStartY = 0;
    touchMoveY = 0;
  });
}

function closeQuickAddModal() {
  const backdrop = document.querySelector('.premium-quickview-backdrop');
  const modal = document.querySelector('.premium-quickview-modal');
  if (backdrop && modal) {
    backdrop.classList.remove('is-active');
    modal.classList.remove('is-active');
    modal.style.transform = '';
  }
}

function openQuickAddModal(cardElement) {
  setupMobileQuickAdd();

  const backdrop = document.querySelector('.premium-quickview-backdrop');
  const modal = document.querySelector('.premium-quickview-modal');
  if (!backdrop || !modal) return;

  const scriptEl = cardElement.querySelector('.product-data-json');
  if (!scriptEl) return;

  let productData;
  try {
    productData = JSON.parse(scriptEl.textContent);
  } catch (err) {
    console.error('Failed to parse product details JSON:', err);
    return;
  }

  // Update light/dark modes
  const headerEl = document.querySelector('header-section');
  let currentTheme = headerEl ? headerEl.getAttribute('data-theme-mode') : 'dark';
  if (currentTheme === 'auto' || !currentTheme) {
    currentTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  modal.setAttribute('data-theme', currentTheme);

  // Populate structural HTML template
  let galleryHtml = '';
  if (productData.images && productData.images.length > 0) {
    galleryHtml += `
      <div class="premium-quickview-gallery">
        <div class="premium-quickview-gallery__track">
    `;
    productData.images.forEach((img) => {
      galleryHtml += `
        <div class="premium-quickview-gallery__slide">
          <img class="premium-quickview-gallery__image" src="${img}" alt="${productData.title}" referrerPolicy="no-referrer" />
        </div>
      `;
    });
    galleryHtml += `
        </div>
    `;
    if (productData.images.length > 1) {
      galleryHtml += `
        <div class="premium-quickview-gallery__dots">
      `;
      productData.images.forEach((_, sIdx) => {
        galleryHtml += `
          <button type="button" class="premium-quickview-gallery__dot ${sIdx === 0 ? 'is-active' : ''}" data-index="${sIdx}" aria-label="Go to slide ${sIdx + 1}"></button>
        `;
      });
      galleryHtml += `
        </div>
      `;
    }
    galleryHtml += `
      </div>
    `;
  }

  let priceHtml = `<span class="premium-quickview-info__price-regular">${productData.price}</span>`;
  if (productData.compare_at_price && productData.compare_at_price_raw && Number(productData.compare_at_price_raw) > Number(productData.price_raw)) {
    priceHtml = `
      <span class="premium-quickview-info__price-regular sale">${productData.price}</span>
      <span class="premium-quickview-info__price-compare">${productData.compare_at_price}</span>
    `;
  }

  let infoHtml = `
    <div class="premium-quickview-info">
      <span class="premium-quickview-info__vendor">${productData.vendor}</span>
      <h3 class="premium-quickview-info__title">${productData.title}</h3>
      <div class="premium-quickview-info__price">
        ${priceHtml}
      </div>
    </div>
  `;

  // Parse options and variants
  const rawVariants = productData.variants || [];
  const normalizedVariants = rawVariants.map((v) => {
    let opts = v.options || [];
    if (opts.length === 0 && v.title) {
      opts = v.title.split('/').map(part => part.trim());
    }
    return {
      id: String(v.id),
      title: v.title,
      available: v.available !== false,
      options: opts
    };
  });

  // Classify options
  let optionsList = productData.options || [];
  if (optionsList.length === 0) {
    const maxOptsCount = Math.max(...normalizedVariants.map(v => v.options.length), 0);
    if (maxOptsCount === 1) {
      // Helper function inside scope
      const isSizeCandidate = (val) => {
        if (!val) return false;
        const normalized = val.trim().toLowerCase();
        const sizeIndicators = ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xs', 'xxs', 'os', 'one size', 'small', 'medium', 'large', 'x-large'];
        return sizeIndicators.includes(normalized) || /^[0-9]+(\.[0-9]+)?$/.test(normalized);
      };
      if (normalizedVariants.some(v => isSizeCandidate(v.options[0]))) {
        optionsList = ['Size'];
      } else {
        optionsList = ['Color'];
      }
    } else if (maxOptsCount >= 2) {
      optionsList = ['Color', 'Size'];
    }
  }

  let colorIdx = optionsList.findIndex(opt => {
    const l = opt.toLowerCase();
    return l.includes('color') || l.includes('colour') || l.includes('shade') || l.includes('edition') || l.includes('style');
  });
  let sizeIdx = optionsList.findIndex(opt => {
    const l = opt.toLowerCase();
    return l.includes('size') || l.includes('fit') || l.includes('dimension');
  });

  // Guess/Fallback if still -1
  if (colorIdx === -1 && sizeIdx === -1 && optionsList.length > 0) {
    const firstV = normalizedVariants[0];
    if (firstV && firstV.options.length > 0) {
      const isSizeCandidate = (val) => {
        if (!val) return false;
        const normalized = val.trim().toLowerCase();
        const sizeIndicators = ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xs', 'xxs', 'os', 'one size', 'small', 'medium', 'large', 'x-large'];
        return sizeIndicators.includes(normalized) || /^[0-9]+(\.[0-9]+)?$/.test(normalized);
      };
      if (firstV.options.length === 1) {
        if (isSizeCandidate(firstV.options[0])) {
          sizeIdx = 0;
        } else {
          colorIdx = 0;
        }
      } else if (firstV.options.length >= 2) {
        if (isSizeCandidate(firstV.options[0])) {
          sizeIdx = 0;
          colorIdx = 1;
        } else {
          colorIdx = 0;
          sizeIdx = 1;
        }
      }
    }
  }

  // Generate unique Colors list - ONLY colors that have available inventory
  let colorsList = [];
  if (colorIdx !== -1) {
    normalizedVariants.forEach(v => {
      const colVal = v.options[colorIdx];
      if (colVal && v.available) {
        if (!colorsList.includes(colVal)) {
          colorsList.push(colVal);
        }
      }
    });
  }

  // Generate unique Sizes list
  let sizesList = [];
  if (sizeIdx !== -1) {
    normalizedVariants.forEach(v => {
      const sizeVal = v.options[sizeIdx];
      if (sizeVal && !sizesList.includes(sizeVal)) {
        sizesList.push(sizeVal);
      }
    });
  }

  // Fallback for simple products with single variant
  if (colorsList.length === 0 && sizesList.length === 0 && normalizedVariants.length > 0) {
    sizesList = normalizedVariants.map(v => v.title);
    sizeIdx = 0;
  }

  // Separate HTML builders for Color and Size selectors
  const getFirstImageForColor = (color) => {
    const allImages = productData.images || [];
    const allAlts = productData.images_alt || [];
    if (!color) return allImages[0] || '';
    const lowerColor = color.trim().toLowerCase();
    for (let index = 0; index < allImages.length; index++) {
      const alt = (allAlts[index] || '').trim().toLowerCase();
      if (alt.includes(lowerColor)) {
        return allImages[index];
      }
    }
    return allImages[0] || '';
  };

  let colorsHtml = '';
  if (colorsList.length > 0) {
    colorsHtml = `
      <div class="premium-quickview-colors">
        <div class="premium-quickview-colors__title">COLOR</div>
        <div class="premium-quickview-colors__grid">
    `;
    colorsList.forEach((c, idx) => {
      const thumbnailImg = getFirstImageForColor(c);
      const activeClass = idx === 0 ? 'is-active' : '';
      colorsHtml += `
        <button type="button" class="premium-quickview-colors__btn image-swatch ${activeClass}" data-color-val="${c}" aria-label="Select color ${c}">
          <img class="premium-quickview-colors__thumbnail" src="${thumbnailImg}" alt="${c}" referrerPolicy="no-referrer" />
        </button>
      `;
    });
    colorsHtml += `
        </div>
      </div>
    `;
  }

  let sizesHtml = '';
  if (sizesList.length > 0) {
    sizesHtml = `
      <div class="premium-quickview-sizes">
        <div class="premium-quickview-sizes__title">SIZE</div>
        <div class="premium-quickview-sizes__grid">
    `;
    sizesList.forEach((s) => {
      sizesHtml += `
        <button type="button" class="premium-quickview-sizes__btn" data-size-val="${s}">
          ${s}
        </button>
      `;
    });
    sizesHtml += `
        </div>
      </div>
    `;
  }

  let ctaHtml = `
    <div class="premium-quickview-ctas">
      <button type="button" class="premium-quickview-add-to-cart" disabled>
        SELECT SIZE
      </button>
      <button type="button" class="premium-quickview-view-product">
        VIEW PRODUCT
      </button>
    </div>
  `;

  const contentEl = modal.querySelector('.premium-quickview-modal__content');
  const footerEl = modal.querySelector('.premium-quickview-modal__footer');
  
  contentEl.innerHTML = galleryHtml + infoHtml + colorsHtml + sizesHtml;
  if (footerEl) {
    footerEl.innerHTML = ctaHtml;
  } else {
    contentEl.innerHTML += ctaHtml;
  }

  // Interactivity Logic
  const colorBtns = modal.querySelectorAll('.premium-quickview-colors__btn');
  const sizeBtns = modal.querySelectorAll('.premium-quickview-sizes__btn');
  const modalAddToCartBtn = modal.querySelector('.premium-quickview-add-to-cart');
  const modalViewProductBtn = modal.querySelector('.premium-quickview-view-product');
  const sizesContainer = modal.querySelector('.premium-quickview-sizes');

  let selectedColor = colorsList.length > 0 ? colorsList[0] : null;
  let selectedSize = null;

  function getImagesForColor(color) {
    const allImages = productData.images || [];
    const allAlts = productData.images_alt || [];

    if (!color) {
      return allImages;
    }

    const lowerColor = color.trim().toLowerCase();

    // Grouping/Filtering by Alt Text
    let matchedImages = [];
    allImages.forEach((img, index) => {
      const alt = (allAlts[index] || '').trim().toLowerCase();
      if (alt.includes(lowerColor)) {
        matchedImages.push(img);
      }
    });

    if (matchedImages.length > 0) {
      return matchedImages;
    }

    // Fallback: If no images match selected color Alt text (or no Alt texts exists), return all images
    return allImages;
  }

  function renderGallery(color) {
    const galleryEl = modal.querySelector('.premium-quickview-gallery');
    if (!galleryEl) return;

    const imagesToRender = getImagesForColor(color);

    let galleryContent = '';
    if (imagesToRender.length > 0) {
      galleryContent += `
        <div class="premium-quickview-gallery__track" style="display: flex; overflow-x: auto; scroll-snap-type: x mandatory; -webkit-overflow-scrolling: touch; width: 100%; height: 100%;">
      `;
      imagesToRender.forEach((img) => {
        galleryContent += `
          <div class="premium-quickview-gallery__slide" style="flex: 0 0 100%; width: 100%; height: 100%; scroll-snap-align: start;">
            <img class="premium-quickview-gallery__image" src="${img}" alt="${productData.title}" referrerPolicy="no-referrer" />
          </div>
        `;
      });
      galleryContent += `
        </div>
      `;
      if (imagesToRender.length > 1) {
        galleryContent += `
          <div class="premium-quickview-gallery__dots">
        `;
        imagesToRender.forEach((_, sIdx) => {
          galleryContent += `
            <button type="button" class="premium-quickview-gallery__dot ${sIdx === 0 ? 'is-active' : ''}" data-index="${sIdx}" aria-label="Go to slide ${sIdx + 1}"></button>
          `;
        });
        galleryContent += `
          </div>
        `;
      }
    } else {
      galleryContent = `
        <div class="premium-quickview-gallery__track">
          <div class="premium-quickview-gallery__slide">
            <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; font-size: 11px; color: var(--modal-muted);">No image available</div>
          </div>
        </div>
      `;
    }

    galleryEl.innerHTML = galleryContent;

    // Set up scroll event and dot clicks for the newly rendered track and dots
    const track = galleryEl.querySelector('.premium-quickview-gallery__track');
    const dots = galleryEl.querySelectorAll('.premium-quickview-gallery__dot');
    if (track && dots.length > 0) {
      track.addEventListener('scroll', () => {
        const slideWidth = track.clientWidth;
        if (slideWidth > 0) {
          const index = Math.round(track.scrollLeft / slideWidth);
          dots.forEach((dot, dotIdx) => {
            if (dotIdx === index) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });
        }
      }, { passive: true });

      dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const index = parseInt(dot.getAttribute('data-index'), 10);
          const slideWidth = track.clientWidth;
          track.scrollTo({
            left: index * slideWidth,
            behavior: 'smooth'
          });
        });
      });
    }
  }

  function updateInteractiveElements() {
    // Dynamically update images list in gallery based on color selection
    renderGallery(selectedColor);

    // 1. If color selection exists, filter size options
    if (colorsList.length > 0 && !selectedColor) {
      sizeBtns.forEach(sb => {
        sb.style.display = 'none';
        sb.classList.remove('is-active');
      });
      if (sizesContainer) {
        sizesContainer.style.display = 'none';
      }
    } else {
      if (sizesContainer) {
        sizesContainer.style.display = 'flex';
      }
      sizeBtns.forEach(sb => {
        const sVal = sb.getAttribute('data-size-val');
        const variant = normalizedVariants.find(v => {
          const hasColorMatch = colorIdx === -1 ? true : v.options[colorIdx] === selectedColor;
          const hasSizeMatch = sizeIdx === -1 ? true : v.options[sizeIdx] === sVal;
          return hasColorMatch && hasSizeMatch;
        });

        if (variant) {
          sb.style.display = ''; // Show size option
          if (variant.available) {
            sb.removeAttribute('disabled');
            sb.classList.remove('is-disabled');
          } else {
            sb.setAttribute('disabled', 'true');
            sb.classList.add('is-disabled');
            sb.classList.remove('is-active');
          }
        } else {
          sb.style.display = 'none'; // Hide if variant doesn't represent this combination
          sb.classList.remove('is-active');
        }
      });
    }

    // 2. Identify selected variant combination
    let matchedVariant = null;
    if (colorsList.length > 0 && sizesList.length > 0) {
      if (selectedColor && selectedSize) {
        matchedVariant = normalizedVariants.find(v => {
          return v.options[colorIdx] === selectedColor && v.options[sizeIdx] === selectedSize && v.available;
        });
      }
    } else if (sizesList.length > 0) {
      if (selectedSize) {
        matchedVariant = normalizedVariants.find(v => {
          return (sizeIdx === -1 ? true : v.options[sizeIdx] === selectedSize) && v.available;
        });
      }
    } else if (colorsList.length > 0) {
      if (selectedColor) {
        matchedVariant = normalizedVariants.find(v => {
          return (colorIdx === -1 ? true : v.options[colorIdx] === selectedColor) && v.available;
        });
      }
    } else {
      matchedVariant = normalizedVariants[0];
    }

    // 3. Update CTA Buttons values and texts
    if (matchedVariant) {
      if (modalAddToCartBtn) {
        modalAddToCartBtn.removeAttribute('disabled');
        modalAddToCartBtn.textContent = 'ADD TO CART';
        modalAddToCartBtn.setAttribute('data-selected-variant-id', matchedVariant.id);
      }
    } else {
      if (modalAddToCartBtn) {
        modalAddToCartBtn.setAttribute('disabled', 'true');
        modalAddToCartBtn.removeAttribute('data-selected-variant-id');
      }

      let btnLabel = 'SELECT SIZE';
      if (colorsList.length > 0 && !selectedColor) {
        btnLabel = 'SELECT COLOR';
      } else if (sizesList.length > 0 && !selectedSize) {
        btnLabel = 'SELECT SIZE';
      } else {
        btnLabel = 'UNAVAILABLE';
      }

      if (modalAddToCartBtn) {
        modalAddToCartBtn.textContent = btnLabel;
      }
    }

    if (modalViewProductBtn) {
      let currentVariantId = '';
      if (matchedVariant) {
        currentVariantId = matchedVariant.id;
      } else if (selectedColor) {
        const matchingColorVariant = normalizedVariants.find(v => v.options[colorIdx] === selectedColor);
        if (matchingColorVariant) {
          currentVariantId = matchingColorVariant.id;
        }
      }
      if (currentVariantId) {
        modalViewProductBtn.setAttribute('data-selected-variant-id', currentVariantId);
      } else {
        modalViewProductBtn.removeAttribute('data-selected-variant-id');
      }
    }
  }

  // Bind Color Option clicks
  colorBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const wasActive = btn.classList.contains('is-active');
      colorBtns.forEach(b => b.classList.remove('is-active'));

      if (wasActive) {
        selectedColor = null;
        selectedSize = null;
      } else {
        btn.classList.add('is-active');
        selectedColor = btn.getAttribute('data-color-val');
        selectedSize = null; // Clear size when color changes
      }

      updateInteractiveElements();
    });
  });

  // Bind Size Option clicks
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const wasActive = btn.classList.contains('is-active');
      sizeBtns.forEach(b => b.classList.remove('is-active'));

      if (wasActive) {
        selectedSize = null;
      } else {
        btn.classList.add('is-active');
        selectedSize = btn.getAttribute('data-size-val');
      }

      updateInteractiveElements();
    });
  });

  // Run initial state setup
  updateInteractiveElements();

  // Bind View Product CTA click
  if (modalViewProductBtn) {
    modalViewProductBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const variantId = modalViewProductBtn.getAttribute('data-selected-variant-id');
      let destinationUrl = productData.url || '#';

      if (destinationUrl === '#') {
        const variantSuffix = variantId ? ` with Variant ID ${variantId}` : '';
        showPremiumToast(`Navigating to product page${variantSuffix} (Placeholder Product)`);
        closeQuickAddModal();
        return;
      }

      if (variantId) {
        if (destinationUrl.includes('?')) {
          destinationUrl += `&variant=${variantId}`;
        } else {
          destinationUrl += `?variant=${variantId}`;
        }
      }

      window.location.href = destinationUrl;
    });
  }

  // Bind Add to Cart CTA click
  modalAddToCartBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const variantId = modalAddToCartBtn.getAttribute('data-selected-variant-id');
    if (!variantId) return;

    modalAddToCartBtn.textContent = '✓ Added to Cart';
    modalAddToCartBtn.classList.add('success-flash');
    modalAddToCartBtn.setAttribute('disabled', 'true');

    const sizeString = selectedSize || 'Standard';
    const colorString = selectedColor || 'Signature Black';

    // Simulated local storage additions
    if (window.ShopifyCart && typeof window.ShopifyCart.addItem === 'function') {
      window.ShopifyCart.addItem({
        id: variantId,
        title: productData.title,
        price: productData.price,
        image: productData.images[0] || '',
        size: sizeString,
        color: colorString
      });
    }

    if (variantId.startsWith('placeholder-')) {
      setTimeout(() => {
        closeQuickAddModal();
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            const cartNotification = document.querySelector('cart-notification');
            if (cartNotification && typeof cartNotification.open === 'function') {
              cartNotification.open();
            }
          }
        }, 500);
      }, 600);
    } else if (!window.ShopifyCart || typeof window.ShopifyCart.addItem !== 'function') {
      const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
        const sectionsToRender = cartElement.getSectionsToRender();
        if (sectionsToRender && Array.isArray(sectionsToRender)) {
          const sectionIds = sectionsToRender.map(s => s.id).join(',');
          formData.append('sections', sectionIds);
        }
        formData.append('sections_url', window.location.pathname);
      }

      fetch(addUrl, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(res => res.json())
      .then(data => {
        if (data.status && data.status === 422) {
          showPremiumToast(`Error: ${data.description || data.message || 'Could not add'}`);
          return;
        }

        return fetch(window.Shopify && window.Shopify.routes ? `${window.Shopify.routes.root}cart.js` : '/cart.js')
          .then(res => res.json())
          .then(cartData => {
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartData } }));
            document.dispatchEvent(new CustomEvent('wearjags-cart-updated', { bubbles: true }));

            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form', 
                productVariantId: variantId, 
                cartData: cartData
              });
            }

            setTimeout(() => {
              closeQuickAddModal();
              setTimeout(() => {
                if (window.ShopifyCart && typeof window.ShopifyCart.refresh === 'function') {
                  window.ShopifyCart.refresh();
                } else {
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer && typeof cartDrawer.open === 'function') {
                    cartDrawer.open();
                  }
                }
              }, 500);
            }, 600);
          });
      })
      .catch(err => {
        setTimeout(() => {
          closeQuickAddModal();
        }, 600);
      });
    }
  });

  // Activate bottom sheet with custom class
  backdrop.classList.add('is-active');
  modal.classList.add('is-active');
}

/* ==========================================================================
   SCROLL REVEAL ANIMATION LOGIC
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.featured-collections-tabs, .collection-discovery-grid');
  
  if (!('IntersectionObserver' in window)) {
    sections.forEach(sec => sec.classList.add('is-revealed'));
    return;
  }

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -5% 0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const section = entry.target;
        section.classList.add('is-revealed');
        
        // Handle stagger delays for cards within this section
        const cards = section.querySelectorAll('.scroll-reveal-bottom');
        cards.forEach((card, index) => {
          // Add stagger delay (approx 120ms between cards)
          card.style.transitionDelay = `${index * 120}ms`;
        });

        obs.unobserve(section);
      }
    });
  }, observerOptions);

  sections.forEach(section => {
    observer.observe(section);
  });
});


